"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGapi = void 0;
// This function returns window.gapi in `any` type, which is necessary
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getGapi() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return window.gapi;
}
exports.getGapi = getGapi;
